export const isAndroid = (userAgent: string) =>
  /android\s*(\d+(?:\.\d+)*)/i.test(userAgent);

export const isIos = (userAgent: string) =>
  /(iPad|iPhone|iPod).*OS ((\d+_?){2,3})/i.test(userAgent);

export const isIosWebView = (userAgent: string) => {
  if (isIos(userAgent)) {
    return /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(userAgent);
  }
  return false;
};

export const isSafari = (userAgent: string) =>
  /^((?!chrome|android).)*safari/i.test(userAgent);

export const isMobile = (userAgent: string) =>
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|HarmonyOS|PlayBook|Opera Mini|Opera Mobi)/i.test(
    userAgent,
  );
